import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  ON24 järelmaksu krediidi kulukuse määr on 28,58% aastas järgmistel näidistingimustel: järelmaksu summa 600€, sissemaks 0%, osamaksete arv 24, intressimäär 22,9%, lepingutas u 19,9€. Järelmaksutaotluse saate esitada ostukorvis, valides makseviisiks Järelmaks.

  <span style="color:#85c1dc;">**FI:**</span>
  

  <span style="color:#85c1dc;">**RU:**</span>
  Ставка затратности кредита в рассрочку ON24 составляет 28,58% в год при следующих примерных условиях: сумма рассрочки 600€, первоначальный взнос 0%, количество платажей 24, процентная ставка 22,9%, плата за заключение договора 19,9€. Вы можете отправить запрос на оплату в рассрочку в корзине, выбрав в качестве способа оплаты Рассрочка.
*/
/* @__NO_SIDE_EFFECTS__ */
const m601 = msg(
  mf`ON24 järelmaksu krediidi kulukuse määr on 28,58% aastas järgmistel näidistingimustel: järelmaksu summa 600€, sissemaks 0%, osamaksete arv 24, intressimäär 22,9%, lepingutas u 19,9€. Järelmaksutaotluse saate esitada ostukorvis, valides makseviisiks Järelmaks.`,
  mf``,
  mf`Ставка затратности кредита в рассрочку ON24 составляет 28,58% в год при следующих примерных условиях: сумма рассрочки 600€, первоначальный взнос 0%, количество платажей 24, процентная ставка 22,9%, плата за заключение договора 19,9€. Вы можете отправить запрос на оплату в рассрочку в корзине, выбрав в качестве способа оплаты Рассрочка.`,
)

export { m601 as 'w.module.product.monthly_pay.disclaimer' }